/* eslint camelcase: 0 */
import { FormControl, Select } from '@mui/material'
import styled from '@emotion/styled/macro'
import theme from 'theme'

const ITEM_HEIGHT = 48
const ITEM_PADDING_TOP = 0

export const AuditLogFormControl = styled(FormControl)<{ isselected?: string; is_opened: string; is_disabled: string }>`
  border: 1px solid ${theme.colors.controlBorder};
  background: transparent;
  outline: none;
  min-width: 113px;
  height: 40px;
  border-radius: ${theme.attributes.borderRadius.large};

  .MuiOutlinedInput-root {
    background: transparent;
    border: 0;
    color: ${theme.colors.foreground};
    text-align: center;
    font-family: ${theme.typography.fontFamily.primary};
    font-size: ${theme.typography.fontSize.large};
    font-style: normal;
    font-weight: ${theme.typography.fontWeight.bold};
    line-height: 20px;
    letter-spacing: 0.1px;
    text-transform: capitalize;
  }

  &:hover {
    border-radius: ${theme.attributes.borderRadius.large};
    background: rgba(234, 221, 255, 0.08);

    .MuiOutlinedInput-root {
      color: ${theme.colors.cta};
    }
  }

  svg {
    top: calc(50% - 0.6em);
    right: ${theme.spacing.small}px;

    path {
      fill: ${theme.colors.cta};
    }
  }

  ${({ is_disabled }) =>
    is_disabled &&
    is_disabled === 'true' &&
    `
      opacity: 0.38;
      pointer-events: none;
      cursor: default;
      
      &:hover {
        border-radius: ${theme.attributes.borderRadius.large};
        background: transparent;
    
        .MuiOutlinedInput-root {
          color: ${theme.colors.cta};
        }
      }
      
       .MuiOutlinedInput-root {
        color: ${theme.colors.cta};
      }
  `};

  ${({ is_opened }) =>
    is_opened &&
    is_opened === 'true' &&
    `
      border: 1px solid ${theme.colors.cta};
      background: rgba(208, 188, 255, 0.16);
      
      .MuiOutlinedInput-root {
        color: ${theme.colors.cta};
      }
  `};

  ${({ isselected }) =>
    isselected &&
    isselected === 'true' &&
    `
    background: rgba(234, 221, 255, 0.08);
    color: ${theme.colors.cta} !important;
    border: 1px solid ${theme.colors.cta} !important;
    
    .MuiOutlinedInput-root {
      border: 1px solid ${theme.colors.cta} !important;
    }
  `};
`

export const AuditLogSelect = styled(Select)<{ isselected?: string; noborder?: string }>`
  min-width: 113px;
  height: 40px;
  background: transparent;
  border-radius: ${theme.attributes.borderRadius.large};
  border: 1px solid ${theme.colors.controlBorder};
  gap: ${theme.spacing.xSmall}px;

  ${({ noborder }) =>
    noborder === 'true' &&
    `
    border-radius: 0;
    border: 0;
    border-color: transparent;
    background: transparent;
  `};

  color: ${theme.baseColors.greyscale[80]};
  text-align: center;
  font-family: ${theme.typography.fontFamily.primary};
  font-size: ${theme.typography.fontSize.large};
  font-weight: ${theme.typography.fontWeight.bold};
  line-height: 20px;
  letter-spacing: 0.1px;
  text-transform: capitalize;

  ${({ isselected }) =>
    isselected === 'true'
      ? `
      background: rgba(234, 221, 255, 0.08);
      color: ${theme.colors.cta} !important;
    
      .MuiOutlinedInput-root {
        .MuiSelect-select {
          color: ${theme.colors.cta} !important;
        }
      }    
  `
      : `     
 .MuiOutlinedInput-input {
    color: ${theme.colors.cta} !important;
  }
  `};

  .MuiOutlinedInput-input {
    padding-right: ${theme.spacing.xLarge}px !important;
  }

  > * {
    border: none !important;
    outline: none !important;
  }

  .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
    border: none !important;
  }

  svg {
    color: ${theme.baseColors.greyscale[80]};
  }
`

export const CategoryMenuProps = {
  PaperProps: {
    sx: {
      marginTop: `${theme.spacing.xSmall}px`,
      background: theme.colors.menuBg,
      boxShadow: theme.attributes.boxShadow.navigation,
      borderRadius: theme.attributes.borderRadius.tertiary,
      minWidth: '167px',
      width: '167px',
      padding: 0,

      '.MuiList-root': {
        padding: 0
      },

      '.MuiMenuItem-root': {
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        minWidth: '167px',
        height: '48px',
        padding: `${theme.spacing.sm}px ${theme.spacing.small}px`,

        '&:first-of-type': {
          paddingTop: '16px'
        },

        '&:last-of-type': {
          paddingBottom: '16px'
        },

        img: {
          marginRight: `${theme.spacing.xSmall}px`
        },

        '&:hover': {
          background: theme.colors.menuItemHover,

          '.MuiListItemText-root .MuiTypography-root': {
            color: `${theme.colors.cta}`
          }
        },

        '.MuiCheckbox-root': {
          marginRight: `${theme.spacing.xSmall}px`,

          '&.Mui-checked': {
            svg: {
              path: {
                fill: theme.colors.cta
              }
            }
          },

          '&:hover': {
            borderRadius: theme.attributes.borderRadius.large,
            background: 'rgba(202, 196, 208, 0.12)'
          },

          svg: {
            width: '18px',
            height: '18px',

            path: {
              fill: theme.baseColors.greyscale[80]
            }
          }
        },

        '.MuiListItemText-root .MuiTypography-root': {
          fontFamily: theme.typography.fontFamily.primary,
          fontWeight: theme.typography.fontWeight.bold,
          fontSize: theme.typography.fontSize.large,
          color: theme.colors.foreground,
          lineHeight: '22px',
          fontStyle: 'normal',
          textTransform: 'capitalize',
          whiteSpace: 'nowrap',
          textOverflow: 'ellipsis',
          overflow: 'hidden'
        },

        '&.Mui-selected': {
          background: `${theme.colors.legacySurfaceContainerBackground2}`,

          "html[data-theme='light'] &": {
            background: theme.colors.cardFillTertiary
          }
        },

        '&[aria-selected="true"]': {
          '.MuiListItemText-root .MuiTypography-root': {
            color: `${theme.colors.cta}`
          }
        }
      },

      '&::-webkit-scrollbar': {
        width: '4px',
        background: 'transparent'
      },

      '&::-webkit-scrollbar-track': {
        boxShadow: 'none',
        background: 'transparent'
      },

      '&::-webkit-scrollbar-thumb': {
        backgroundColor: '#FBD8F5',
        borderRadius: theme.attributes.borderRadius.secondary,

        "html[data-theme='light'] &": {
          backgroundColor: theme.colors.dropdownBorder
        }
      }
    },
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP
    }
  },
  anchorOrigin: {
    vertical: 'bottom' as const,
    horizontal: 'left' as const
  },
  transformOrigin: {
    vertical: 'top' as const,
    horizontal: 'left' as const
  },
  variant: 'menu' as const
}
